import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './style.scss';
// Components
import Modal from '../Modal';
import CancelButton from '../../buttons/CancelButton';
import { Button } from '@gulfwinds/ui-components';
import BaseInput from '../../inputs/BaseInput';
import { DeleteButton } from 'shared/buttons';

const ConfirmDialogue = ({
  isOpen = false,
  handleClose,
  headerText = 'Confirm?',
  showInput,
  text = 'Are you sure?',
  confirmText = 'Yes',
  cancelText = 'No',
  ConfirmComponent,
  containerStyle,
  ...props
}) => {
  const [inputText, setInputText] = useState();

  return (
    <Modal
      isOpen={isOpen}
      handleClose={() => handleClose(false)}
      containerStyle='app-modal app-modal-small confirm-modal'
      title={headerText}
    >
      <div className='app-modal-body'>
        {text}
        {showInput && (
          <BaseInput
            id='new-group-groupName'
            name='groupName'
            value={inputText}
            onChange={(event) => setInputText(event.target.value)}
          />
        )}
        <div className='app-modal-footer'>
          {ConfirmComponent ? (
            <ConfirmComponent onClick={() => handleClose(true, inputText)} title={confirmText} {...props} />
          ) : (
            <Button primary onClick={() => handleClose(true, inputText)} {...props}>
              {confirmText}
            </Button>
          )}
          <CancelButton title={cancelText} onClick={() => handleClose(false)} />
        </div>
      </div>
    </Modal>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  headerText: PropTypes.string,
  text: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  confirmComponent: PropTypes.func,
};

export const ConfirmDeleteDialogue = (props) => (
  <ConfirmDialogue
    headerText='Confirm Delete'
    ConfirmComponent={DeleteButton}
    cancelText='Cancel'
    text="Are you sure you would like to delete this?"
    {...props}
  />
);

export default ConfirmDialogue;
